import { createSlice } from '@reduxjs/toolkit'

type UserDetail = {
  authToken?: string
  expiresIn?: string
  userId?: number | string
  name?: string
  email?: string
  authType?: string
  allowedGroups: {
    groupId: string
    domainDivisionRegionId: number
    role: string
  }[]
  domainDivisionRegionId?: number[]
}
type InitialState = {
  user: UserDetail
}

const initialState: InitialState = {
  user: { allowedGroups: [] },
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (state, action) => {
      const { auth } = action.payload
      state.user = auth
    },
  },
})

// Action creators are generated for each case reducer function
export const { setAuth } = authSlice.actions

export default authSlice.reducer
